<template>
  <!-- 导出:  新一轮职业教育专业教学资源库 建设及应用监测分析报告-->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
      <input id="completeNum" v-model="completeNum" v-show="false" />
      <!-- PDF  首页 -->
      <div class="HomePage page-box">
        <!-- 图片 -->
        <div id="image"></div>
        <!-- 正文 -->
        <div id="PdfTitle">
          <p id="FristTitle">新一轮职业教育专业教学资源库</p>
          <div>
            <p id="FristTitle"><span v-if="type == 1">建设及应用监测月度分析报告</span><span v-if="type == 2">建设及应用监测季度分析报告</span><span v-if="type == 3">建设及应用监测年度分析报告</span></p>
          </div>
          <p id="SecondTitle" v-if="type == 1">
            <span id="ThrendTitle">（{{ nowYear }}年{{ nowMonth }}月）</span>
          </p>
          <p id="SecondTitle" v-if="type == 2">
            <span id="ThrendTitle">（{{ nowYear }}年{{ Quarter }}）</span>
          </p>
          <p id="SecondTitle" v-if="type == 3">
            <span id="ThrendTitle">（{{ nowYear }}年）</span>
          </p>
          <p id="FourTitle">运行分析起止时间：{{ startDay }}至{{ endDay }}</p>
        </div>

        <!-- 底部 -->
        <div id="foot">
          <div class="footBox">
            <p>职业教育专业教学资源库运行监测平台项目组</p>
            <p>广东轻工职业技术大学产教融合大数据研究所</p>
            <p>
              <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
              <span v-else>{{ +nowYear + 1 }}年</span>
              <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
              ><span v-else>1</span> 月 15 日
            </p>
          </div>
        </div>
      </div>

      <!-- 目录 -->
      <div class="catalogue page-box">
      <div class="title">
        <h3>目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</h3>
      </div>
      <h5>1. 监测总览<span class="dot"></span>1</h5>
      <h5 class="Second_text">1.1 用户建设及应用情况<span class="dot"></span>1</h5>
      <h5 class="Second_text">1.2 课程建设及应用情况<span class="dot"></span>2</h5>
      <h5 class="Second_text">1.3 资源建设及应用情况<span class="dot"></span>3</h5>
      <h5 class="Second_text">1.4 原国家级资源库建设及应用情况分析<span class="dot"></span>3</h5>
      <h5>2. 各省利用资源库开展教学总体情况<span class="dot"></span>5</h5>
      <h5 class="Second_text">2.1 各省用户建设及应用情况<span class="dot"></span>5</h5>
      <h5 class="Second_text">2.2 各省课程建设及应用<span class="dot"></span>5</h5>
      <h5 class="Second_text">2.3 各省资源建设及应用<span class="dot"></span>6</h5>
      <h5>3.&nbsp;
        <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
        <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
        <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
        <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>
        资源库运行情况分析<span class="dot"></span>6</h5>
      <h5 class="Second_text">
        3.1&nbsp;<span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
        <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
        <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
        <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>
        资源库用户建设及应用情况<span class="dot"></span>6
      </h5>
      <h5 class="Second_text">
        3.2&nbsp;<span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
        <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
        <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
        <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库课程建设及应用情况<span class="dot"></span>8
      </h5>
      <h5 class="Second_text">
        3.3&nbsp;<span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
        <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
        <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
        <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库资源建设及应用情况<span class="dot"></span>8
      </h5>
      <h5 class="Second_text">
        3.4&nbsp;<span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
        <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
        <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
        <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库运行情况<span class="dot"></span>10
      </h5>
    </div>


      <!-- 第一页 -->
      <div class="chart_box page-box">
        <div class="header_titles">
          <h1 style="font-size: 60px">新一轮职业教育专业教学资源库</h1>
          <h1 style="margin-top: 15px;font-size: 60px" v-if="type == 1">
            建设及应用监测月度分析报告（{{ nowYear }}年{{ nowMonth }}月）
          </h1>
          <h1 style="margin-top: 20px;font-size: 60px" v-if="type == 2">
            建设及应用监测季度分析报告（{{ nowYear }}年{{ Quarter }}）
          </h1>
          <h1 style="margin-top: 20px;font-size: 60px" v-if="type == 3">
            建设及应用监测年度分析报告（{{ nowYear }}年）
          </h1>
          <div class="number_time">
            <div>
              <span></span>
              <span>统计时间：{{ startDay }}至{{ endDay }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="division">1. 监测总览</div>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，新一轮职业教育专业教学资源库共计{{zykMonitorDetail.push_data_zyk + zykMonitorDetail.no_push_zyk}}个，已纳入监测并正常推送数据的资源库项目有{{zykMonitorDetail.push_data_zyk}}个，未纳入监测或未正常推送数据的资源库项目有{{zykMonitorDetail.no_push_zyk}}个。
          以下内容为针对已纳入监测并正常推送数据的{{zykMonitorDetail.push_data_zyk}}个资源库项目建设及应用情况的分析结果。<br/>
        </p>
        <p>
          在{{zykMonitorDetail.push_data_zyk}}个已纳入监测并正常推送数据的资源库项目中，原国家级资源库{{ zykMonitorDetail.country }}个，省市级资源库{{
          zykMonitorDetail.province
          }}个，院校级资源库{{ zykMonitorDetail.school }}个，覆盖了{{
            getmajor.dataList.length - 1
          }}个专业大类和{{zykProfessionClass}}个专业类。目前，已有{{ dataAll.dataList.zykSchoolCount }}余所职业院校和{{
            dataAll.dataList.companyNum
          }}余家行业企业参与建设，标准化课程总量已达{{
            getUtils_Fun(getcourse.Standardization.value)
          }}门，资源总量达{{ getUtils_Fun(educationLevel.total) }}余条，资源存储总容量有 {{formatValue(zykResourceStorage/1024/1024)}} TB ，共有注册用户{{
            getUtils_Fun(dataAll.dataList.zykUserNum)
          }}余人，总访问量{{ getUtils_Fun(dataAll.dataList.zykVisitNum) }}次，覆盖平台数13个，形成了国家、省、学校三级互补的优质资源共建共享体系，有力地推动了信息技术在职业教育专业教学和职业培训领域综合应用。具体建设及应用情况如下：
        </p><!--todo 暂时写死平台数-->
        <h4>1.1 用户建设及应用情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库共有注册用户{{
            getUtils_Fun(dataAll.dataList.zykUserNum)
          }}余人，按用户身份类型统计，教师{{ getUtils_Fun(zykUserNum.teacher) }}余人，其中实名教师{{
          getUtils_Fun(zykUserNum.realNameTeacher)
          }}余人，学生{{
            getUtils_Fun(studentSum)
          }}余人，其中实名学生{{
          getUtils_Fun(zykUserNum.realNameStudent)
          }}余人。资源库企业用户{{ getUtils_Fun(zykUserNum.enterprise) }}余人
          ，能够较好地考虑了企业员工继续教育、技能提升的需求，合作企业实现了依托资源库开展员工继续教育培训；资源库共有社会学习者用户{{
            getUtils_Fun(zykUserNum.social)
          }}余人，努力承担面向普通劳动者免费线上培训的社会责任。
        </p>
        <p>用户类型分布详情如下所示：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="zykUserNum.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图1 资源库用户整体情况</div>

        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="studentConstruction.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图2 资源库学生类型分布情况</div>
      </div>

      <!-- 第二页 -->
      <div class="chart_box page-box">
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="teaAstudVisit.dataList"
            :transverseData="teaAstudVisit.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="teaAstudVisit.legendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图3 资源库最近一年教师和学生访问情况</div>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="enterAsoci.dataList"
            :transverseData="enterAsoci.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="enterAsoci.legendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name" style="margin-top: 0">
          图4 资源库最近一年社会学习者和企业用户访问情况
        </div>
        <h4>1.2 课程建设及应用情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库项目课程总量达到{{
            getUtils_Fun(getcourse.total)
          }}门，其中{{ getcourse.individualization.name
          }}{{ getUtils_Fun(getcourse.individualization.value) }}门，{{
            getcourse.Standardization.name
          }}{{ getUtils_Fun(getcourse.Standardization.value) }}门。
          其中，注册学生用户访问最多的课程是《{{
            courseDataAll.name && courseDataAll.name.split("-")[0]
          }}》，属于“{{ courseDataAll.zykName }}资源库”。在{{
            courseDataAll.zykDiv
          }}%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下：
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="getcourse.dataList"
            :transverseData="getcourse.transverseData"
            :colorList="getcourse.colorList"
          >
          </tcolumnarChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图5 资源库课程整体情况</div>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="courseVisit.dataList"
            :transverseData="courseVisit.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图6 资源库最近一年课程访问情况</div>
      </div>

      <!-- 第三页 -->
      <div class="chart_box page-box">
        <h4>1.3 资源建设及应用情况</h4>
        <p>
          资源库项目资源数量达{{
          getUtils_Fun(educationLevel.total)
          }}条，存储总容量{{
          formatValue(zykResourceStorage/1024/1024)
          }}TB，原创资源占比{{formatValue(educationLevel.originalResourceNum/educationLevel.total)*100}}%，资源访问总量已达{{ getUtils_Fun(VisitAll.resource) }}余次。 题库数量{{getUtils_Fun(resourceBuildApply.questionNum)}}条，题库使用率{{resourceBuildApply.questionActivePercent}}。
          所有资源中图形(图像)类和文本类资源占比{{resourceBuildApply.textImgePercent}}；“{{
          educationLevel.Max.name
          }}”资源数量最多，达到{{
          getUtils_Fun(educationLevel.Max.value)
          }}条，占比{{educationLevel.videoPercent}}%；微课有{{getUtils_Fun(resourceBuildApply.smallCourse)}}门，占比{{educationLevel.smallCoursePercent}}%。除此之外，各资源库项目还开发了大量的实践教学资源， 拥有{{getUtils_Fun(educationLevel.xuni.value)}}条虚拟仿真资源。
        </p>
        <p>
          资源库项目中核心专业人才培养方案{{ extraResourceData.talent_training_num }}份；
          标准化课程知识图谱{{ extraResourceData.knowledge_graph_num }}份；
          课程教学标准或规范{{ extraResourceData.teaching_standard_num }}份；
          题库有{{getUtils_Fun(extraResourceData.question_num)}}道题，题库使用率平均达{{ formatValue(extraResourceData.question_bank_use_rate_avg) }}%。
        </p>
        <p>资源按类型分布详情如下：</p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="educationLevel.dataList"
            :colorName="1"
            :innerText="'数量'"
            :showValue="true"
            :unit="'条'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图7 资源库资源整体情况</div>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="resource.dataList"
            :transverseData="resource.transverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
            :isaverage="true"
          >
          </discountChart>
        </div>
        <div class="chart_name" style="margin-top: 0">图8 资源库最近一年资源访问情况</div>
        <h4 style="margin-top: 200px">1.4 原国家级资源库建设及应用情况分析</h4>
        <p>1. 归属专业大类</p>
        <p>
          在203个原国家级资源库中有{{zykMonitorDetail.country}}个资源库参与了新一轮资源库的建设。截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{zykMonitorDetail.country}}个原国家级资源库覆盖{{
          getmajor.dataList.length - 1
          }}个专业大类。从专业大类分布看，属于“{{ getmajor.MaxArr.name }}”的资源库最多，占比达{{
          ((getmajor.MaxArr.value / this.getmajor.total) * 100).toFixed(2)
          }}%，具体分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="getmajor.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :showValue="true"
            :unit="'个'"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图9 原国家级资源库专业大类分布情况</div>
      </div>
      <!-- 第四页 -->
      <div class="chart_box page-box">
        <p>2. 按照访问量排名</p>
        <p>
          原国家级资源库项目中，“{{
            getzykTable.FristArr.zykName.replace("资源库", "")
          }}资源库”的访问量最多，紧随其后的是“{{
            getzykTable.SecArr.zykName.replace("资源库", "")
          }}资源库”和“{{
            getzykTable.ThrArr.zykName.replace("资源库", "")
          }}资源库”。具体按照访问情况排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表5 原国家级资源库访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>访问量（次）</th>
              <th>用户数（人）</th>
              <th>课程数（门）</th>
              <th>资源数（条）</th>
            </tr>

            <tr
              v-for="(item, index) in getzykTable.dataList"
              :key="index"
              v-show="getzykTable.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ item.logNum }}</td>
              <td>{{ item.userCount }}</td>
              <td>{{ item.courseNum }}</td>
              <td>{{ item.resourceCount }}</td>

            </tr>

            <tr v-show="getzykTable.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top150">3. 按照用户活跃情况排名</p>
        <p>
          原国家级资源库项目中，“{{
            getzykACtive.Frist.name.replace("资源库", "")
          }}资源库”的活跃用户数最多，紧随其后的是“{{
            getzykACtive.Second.name.replace("资源库", "")
          }}资源库”和“{{ getzykACtive.Thrid.name.replace("资源库", "") }}资源库”。
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="getzykACtive.dataList"
            :transverseData="getzykACtive.transverseData"
            :colorList="getzykACtive.colorList"
            :gridY="'5%'"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图10 原国家级资源库活跃用户排名情况（前十五名）</div>
      </div>

      <!-- 第五页 -->
      <div class="chart_box page-box">
        <div class="division">2. 各省利用资源库开展教学总体情况</div>
        <h4>2.1 各省用户建设及应用情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
          getUtils_Fun(zykUserNum.sum)
          }}，其中注册用户最多的是<span v-if="userProvince.MaxArr.province">{{ changeCity(userProvince.MaxArr.province) }}</span>资源库，达{{
          getUtils_Fun(userProvince.MaxArr.num)
          }}人；交流互动次数累计{{ getUtils_Fun(VisitAll.user) }}次，互动交流频次最多的是{{
          changeCity(userProvince.from.province)
          }}资源库，达{{ getUtils_Fun(userProvince.from.num) }}次；活跃用户总数{{
          getUtils_Fun(userProvince.studyTotal)
          }}，活跃用户数最多的是{{ changeCity(userProvince.MaxArr.province) }}资源库，共{{
          getUtils_Fun(userProvince.onilneMax.activeNum)
          }}人。具体各省资源库用户按照活跃用户数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表6 各省资源库活跃用户数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源库数（个）</th>
              <th>活跃用户数（人）</th>
              <th>注册用户数（人）</th>
              <th>交流互动量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in userProvince.dataList.slice(0, 15)"
              :key="index"
              v-show="userProvince.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.activeNum }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.formun }}</td>
            </tr>

            <tr v-show="userProvince.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <!--        <div class="standards_content echartsHeight" style="height: 1000px">-->
        <!--          <distributionChart-->
        <!--            :refId="'userTalk'"-->
        <!--            :datas="userProvince.mapdatas"-->
        <!--            :color="userProvince.mapcolorList"-->
        <!--            :isExportFont="18"-->
        <!--            :zoom="true"-->
        <!--          ></distributionChart>-->
        <!--        </div>-->
        <!--        <div class="chart_name" style="margin-top: 0">图11 各省资源库访问热力图</div>-->
        <p class="notes">
          注：“各省资源库” 均以该资源库的第一主持院校所在地来确定该资源库所归属的省份。
        </p>
        <h4 style="margin-top: 150px">2.2 各省课程建设及应用</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设课程总计{{
          getUtils_Fun(getcourse.total)
          }}门，其中建设课程数量最多的是{{ changeCity(curriculum.MaxArr.name) }}资源库，有{{
          getUtils_Fun(curriculum.MaxArr.value)
          }}门；标准化课程数累计有{{ getUtils_Fun(getcourse.Standardization.value) }}门，
          标准化课程数最多的是{{ changeCity(curriculProvince.standard.name) }}资源库，共{{
          getUtils_Fun(curriculProvince.standard.snum)
          }}门，个性化课程数累计有{{
          getUtils_Fun(getcourse.individualization.value)
          }}门，个性化课程数最多的{{ changeCity(curriculProvince.personality.name) }}资源库，有{{
          getUtils_Fun(curriculProvince.personality.pnum)
          }}门。 具体各省按照总课程数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表7 各省资源库按照课程总量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源库数（个）</th>
              <th>总课程数（门）</th>
              <th>标准化课程数</th>
              <th>个性化课程数</th>
            </tr>

            <tr
              v-for="(item, index) in curriculProvince.dataList.slice(0, 15)"
              :key="index"
              v-show="curriculProvince.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.snum }}</td>
              <td>{{ item.pnum }}</td>
            </tr>

            <tr v-show="curriculProvince.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第六页 -->
      <div class="chart_box page-box">
        <h4 class="m-top150">2.3 各省资源建设及应用</h4>
        <p v-if="disksNum.buildMax.province1!=undefined">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设资源累计达{{
          getUtils_Fun(educationLevel.total)
          }}条，其中建设资源数量最多的是{{ changeCity(disksNum.buildMax.province1) }}资源库，有{{
          getUtils_Fun(disksNum.buildMax.count)
          }}条。各省访问资源的总量达{{ getUtils_Fun(VisitAll.resource) }}次， 访问资源总量最多的是{{
          changeCity(disksNum.MaxArr.province1)
          }}资源库。具体各省资源库资源建设按照访问量情况排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表8 各省资源库资源访问量情况排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>资源库数（个）</th>
              <th>访问量（次）</th>
              <th>资源数（条）</th>
              <th>资源量（TB）</th>
            </tr>

            <tr
              v-for="(item, index) in disksNum.dataList.slice(0, 15)"
              :key="index"
              v-show="disksNum.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province1 }}</td>
              <td>{{ item.zykCount }}</td>
              <td>{{ item.log }}</td>
              <td>{{ item.count }}</td>
              <td>{{ item.disksNum.toFixed(2) }}</td>
            </tr>

            <tr v-show="disksNum.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <div class="division">3. <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库运行情况分析</div>
        <h4>3.1. <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库用户建设及应用情况</h4>
        <p>1. 用户新增情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，用户新增总数为{{ getUtils_Fun(userAdd.total) }}，其中学生用户新增共{{
          getUtils_Fun(userAdd.Stotal)
          }}人，教师用户新增共{{ getUtils_Fun(userAdd.Ttotal) }}人。师生用户新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="userAdd.sAtdatas"
            :transverseData="userAdd.transverse"
            :colorList="userAdd.colorList"
            :innerText="'单位：人'"
            :legendList="userAdd.sAtlegendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图11           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库师生用户新增趋势</div>
      </div>

      <!-- 第七页 -->
      <div class="chart_box page-box">
        <p class="m-top150">2. 用户活跃情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，资源库项目中累计活跃用户{{ getUtils_Fun(activeUserTotal) }}人，累计访问{{
            getUtils_Fun(logTotal)
          }}次。其中，{{ zykuserYun.roleStudent.role }}活跃用户{{
            getUtils_Fun(zykuserYun.roleStudent.num)
          }}人，累计访问{{ getUtils_Fun(zykuserYun.roleStudent.logNum) }}次；{{
            zykuserYun.roleTeacher.role
          }}活跃用户{{ getUtils_Fun(zykuserYun.roleTeacher.num) }}人，累计访问{{
            getUtils_Fun(zykuserYun.roleTeacher.logNum)
          }}次；企业员工{{ getUtils_Fun(zykuserYun.roleEnterprise.num) }}人，累计访问{{
            getUtils_Fun(zykuserYun.roleEnterprise.logNum)
          }}次； 社会学习者{{ getUtils_Fun(zykuserYun.roleSocial.num) }}人，累计访问{{
            getUtils_Fun(zykuserYun.roleSocial.logNum)
          }}次。各类型用户访问趋势图如下：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="zykuserYun.userActiveRoleData"
            :transverseData="zykuserYun.userActiveRoleTranserve"
            :colorList="zykuserYun.colorList"
            :innerText="'单位：次'"
            :legendList="zykuserYun.userActiveRolelegendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图12           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库各类型用户访问趋势</div>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，资源库平均日活
          <span v-if="this.type==1">
               {{getUtils_Fun(zykuserYun.userActiveTotal / 30)}}
          </span>
          <span v-if="this.type==2">
               {{getUtils_Fun(zykuserYun.userActiveTotal / 90)}}
          </span>
          <span v-if="this.type==3">
               {{getUtils_Fun(zykuserYun.userActiveTotal / 365)}}
          </span>
          人。日活趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="zykuserYun.userActiveData"
            :transverseData="zykuserYun.userActiveTranserve"
            :colorList="zykuserYun.colorList"
            :colorName="1"
            :innerText="'单位：人'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图13           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库日活趋势</div>

        <p class="m-top150">3. 用户访问情况排名</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，被用户访问最多的资源库是{{ userTop.fristMax.projectTypeCn }}的“{{
          userTop.fristMax.zykName.replace("资源库", "")
          }}资源库”。具体被访问资源库排名 (前十五名)如下表所示：
        </p>
        <div class="chart_name">
          表9           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span> 资源库用户访问情况排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>级别</th>
              <th>访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in userTop.fristTop15"
              :key="index"
              v-show="userTop.fristTop15.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ item.projectTypeCn == '国家级'?'原国家级':item.projectTypeCn}}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="userTop.fristTop15.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第八页 -->
      <div class="chart_box page-box">
        <h4>3.2           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库课程建设及应用情况</h4>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，资源库新增课程总数共{{ courseNew.total }}门，其中标准化课程{{
          courseNew.sNum
          }}门，个性化课程{{ courseNew.pNum }}门。具体课程新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="courseNew.dataList"
            :transverseData="courseNew.transverse"
            :colorList="courseNew.colorList"
            :colorName="1"
            :innerText="'单位：门'"
            :isaverage="true"
          ></discountChart>
          <div class="chart_name">图14           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
            <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
            <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
            <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span> 资源库课程新增趋势</div>
        </div>
        <p class="m-top150">
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，被访问量居首的课程是《{{ courseTalkTable.MaxArr.name }}》，有{{
          getUtils_Fun(courseTalkTable.MaxArr.num)
          }}次，具体课程按照访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表10           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库课程被访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>所属资源库</th>
              <th>级别</th>
              <th>第一主持院校</th>
              <th>访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in courseTalkTable.dataList"
              :key="index"
              v-show="courseTalkTable.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.project_type_cn == '国家级'?'原国家级':item.project_type_cn}}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.num }}</td>
            </tr>

            <tr v-show="courseTalkTable.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4>3.3           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库资源建设及应用情况</h4>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，资源库新增资源数为{{
          getUtils_Fun(zyktalk.total)
          }}条，具体资源库新增资源数排名（前十五名）情况如下：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="zyktalk.resourceDistribution"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :showValue="true"
            :unit="'条'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图15           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库新增资源类型分布情况</div>
      </div>

      <!-- 第十页 -->
      <div class="chart_box page-box">
        <div class="chart_name m-top150">
          表11           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库按照新增的资源数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>级别</th>
              <th>新增资源数（条）</th>
            </tr>
            <tr
              v-for="(item, index) in zyktalk.newRank"
              :key="index"
              v-show="zyktalk.newRank.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.project_type_cn == '国家级'?'原国家级':item.project_type_cn}}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="zyktalk.newRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p style="margin-top: 150px">
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，资源库资源被访问总量达{{ getUtils_Fun(zyktalk.totalLog) }}次，其中，“{{
          zyktalk.MaxArr.zyk_name.replace("资源库", "")
          }}资源库”的资源被访问的次数最多。资源库按照资源被访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表12           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>资源库按照资源被访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>级别</th>
              <th>资源访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in zyktalk.logRank"
              :key="index"
              v-show="zyktalk.logRank.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.project_type_cn == '国家级'?'原国家级':item.project_type_cn}}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="zyktalk.logRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第十一页 -->
      <div class="chart_box page-box">
        <h4 class="m-top150">3.4           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库运行情况</h4>
        <h5>3.4.1           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库用户新增情况</h5>
        <p>1. 用户新增情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，原国家级资源库中新增用户总数为{{
          getUtils_Fun(CountryUserAdd.total)
          }}人，占总体新增用户总数{{getUtils_Fun((CountryUserAdd.total/CountryUserAdd.allZykUserAddNum)*100)}}%，其中学生用户新增共{{ getUtils_Fun(CountryUserAdd.Ttotal) }}人，教师用户新增共{{
          getUtils_Fun(CountryUserAdd.Stotal)
          }}人。师生用户新增趋势如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="CountryUserAdd.dataList"
            :transverseData="CountryUserAdd.transverseData"
            :colorList="userAdd.colorList"
            :innerText="'单位：人'"
            :legendList="userAdd.sAtlegendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">图16           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库师生用户新增趋势</div>
        <p style="margin-top: 150px">2. 用户活跃情况</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，原国家级资源库项目中累计活跃用户{{
          getUtils_Fun(userRunCase.activeUserTotal)
          }}人，累计访问{{ getUtils_Fun(userRunCase.logTotal) }}次。其中，学生活跃用户{{
          getUtils_Fun(CountryCurAdd.studentActive.num)
          }}人，累计访问共{{ getUtils_Fun(CountryCurAdd.studentActive.logNum) }}次；教师活跃用户{{
          getUtils_Fun(CountryCurAdd.teacherActive.num)
          }}人，累计访问共{{ getUtils_Fun(CountryCurAdd.teacherActive.logNum) }}次；企业员工{{
          getUtils_Fun(CountryCurAdd.enterpriseActive.num)
          }}人，累计访问{{ getUtils_Fun(CountryCurAdd.enterpriseActive.logNum) }}次； 社会学习者{{
          getUtils_Fun(CountryCurAdd.societyActive.num)
          }}人，累计访问资源库{{
          getUtils_Fun(CountryCurAdd.societyActive.logNum)
          }}次。各类型用户访问趋势图如下：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'userTalk'"
            :datas="CountryCurAdd.userVisitDataList"
            :transverseData="CountryCurAdd.userVisitTransverseData"
            :colorList="colorList"
            :innerText="'单位：次'"
            :legendList="CountryCurAdd.userVisitLegendList"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :circleSize="80"
          ></discountChart>
        </div>
        <div class="chart_name">
          图17           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库各类型用户访问趋势
        </div>
      </div>

      <!-- 第十二页 -->
      <div class="chart_box page-box">
        <p class="m-top150">3. 用户访问情况排名</p>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，被用户访问最多的原国家级资源库是“{{
            CountryVisit.FristZykVisit.zykName.replace("资源库", "")
          }}资源库”。具体被访问资源库排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表13           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库访问量排行榜（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>序号</th>
              <th>资源库名称</th>
              <th>第一主持院校</th>
              <th>访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in CountryVisit.FristdataList"
              :key="index"
              v-show="CountryVisit.FristdataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zykName }}</td>
              <td>{{ item.firstChargeUnit }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="CountryVisit.FristdataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <h5 class="m-top150">3.4.2           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库课程运行情况</h5>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，原国家级资源库新增课程总数共{{
          getUtils_Fun(CountryCuourse.courseTotal)
          }}门，占整体资源库新增课程数的{{formatValue((CountryCuourse.courseTotal/CountryCuourse.allZykAddCourse)*100)}}%，其中标准化课程{{ CountryCuourse.standardNum }}门，个性化课程{{
          CountryCuourse.personalityNum
          }}门。具体新增情况如下：
        </p>
        <div class="standards_content echartsHeight">
          <discountChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'resourcesMonthChart'"
            :datas="CountryCuourse.dataList"
            :transverseData="CountryCuourse.transverseData"
            :colorList="colorList"
            :colorName="1"
            :innerText="'单位：门'"
            :isaverage="true"
          ></discountChart>
        </div>
        <div class="chart_name">图18           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库课程新增趋势</div>
      </div>
      <!-- 第十三页 -->
      <div class="chart_box page-box">
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，被访问量居首的课程是《{{ CountryCourseVisit.Max.name }}》，有{{
          getUtils_Fun(CountryCourseVisit.Max.num)
          }}次，具体课程按照访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表14 <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库课程被访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>所属资源库</th>
              <th>课程负责人</th>
              <th>访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in CountryCourseVisit.dataList"
              :key="index"
              v-show="CountryCourseVisit.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.author }}</td>
              <td>{{ item.num }}</td>
            </tr>

            <tr v-show="CountryCourseVisit.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h5 class="m-top150">3.4.3
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库资源运行情况</h5>
        <p>
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，原国家级资源库新增资源数为{{
          getUtils_Fun(CountryResourcesAdd.total)
          }}条，占整体资源库新增资源数的{{formatValue(CountryResourcesAdd.total/CountryResourcesAdd.allZykAddTotal)*100}}%，具体资源库新增资源数排名（前十五名）情况如下表所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :isShowTextColor="true"
            :refId="'typeDistributionChart'"
            :datas="CountryResourcesAdd.resourceDistribution"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'50%'"
            :showValue="true"
            :unit="'条'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">
          图19           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库新增资源类型分布情况
        </div>
      </div>

      <div class="chart_box page-box">
        <div class="chart_name" style="margin-top: 50px">
          表15           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库按照新增的资源数排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>新增资源数（条）</th>
            </tr>

            <tr
              v-for="(item, index) in CountryResourcesAdd.newRank"
              :key="index"
              v-show="CountryResourcesAdd.newRank.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="CountryResourcesAdd.newRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top150">
          <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>，原国家级资源库资源被访问总量达{{
          getUtils_Fun(CountryResourcesAdd.totalLog)
          }}次，其中，“{{
          CountryResourcesAdd.visitRankTop1.zyk_name.replace("资源库", "")
          }}资源库”的资源数被访问的次数最多。资源库按照资源被访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">
          表16           <span v-if="type==1">{{ startDay.split("-")[0] + '年' + startDay.split("-")[1] + '月' }}</span>
          <span v-if="type==2">{{ startDay.split("-")[0] + '年' + Quarter }}</span>
          <span v-if="type==3">{{ startDay.split("-")[0] + '年'}}</span>
          <span v-if="type!=1&&type!=2&&type!=3">{{ startDay }}至{{ endDay }}</span>原国家级资源库按照资源被访问量排名（前十五名）
        </div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>资源库</th>
              <th>第一主持院校</th>
              <th>资源访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in CountryResourcesAdd.logRank"
              :key="index"
              v-show="CountryResourcesAdd.logRank.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.zyk_name }}</td>
              <td>{{ item.first_charge_unit }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="CountryResourcesAdd.logRank.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; // 引入水滴图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import mapChart from "@/components/chart/mapChart.vue"; // 地图
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart,
    mapChart,
  },
  data() {
    return {
      resourceBuildApply:{},
      zykWholeRankSorByUserNum:[],
      zykWholeRankSorByActiveUserNum:[],
      zykWholeRankSorByCourseCount:[],
      zykWholeRankSorByResourceNum:[],
      zykWholeRankSorByLogNum:[],
      zykResourceStorage:0,
      zykProfessionClass:0,
      zykMonitorDetail:{},
      logTotal: 0,
      activeUserTotal: 0,
      completeNum: 0, //统计接口数量
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      // 数据总览
      dataAll: {
        dataList: {},
        courseTotal: null,
      },
      platformNum: {}, //平台数
      // 资源等级
      resourceLevel: {
        dataList: [],
        countryNum: {},
        provinceNum: {},
        schoolNum: {},
        zyktotal: {},
      },

      // 资源库用户数
      zykUserNum: {
        dataList: [],
        total: null,
        teacher: 0,
        student: 0,
        realNameTeacher: 0,
        realNameStudent: 0,
        enterprise: 0,
        social: 0,
        other: 0,
      },

      // 总访问量
      VisitAll: {
        resource: 0,
        course: {},
      },

      // 学生类型整体情况
      studentConstruction: {
        dataList: [],
        total: 0,
      },
      // 学生 + 老师 近一年访问情况
      teaAstudVisit: {
        dataList: [],
        colorList: [],
        legendList: [],
        transverseData: [],
      },
      // 企业用户 + 社会学习者 近一年访问情况
      enterAsoci: {
        dataList: [],
        colorList: [],
        legendList: [],
        transverseData: [],
      },
      // 课程画像-课程数量图
      getcourse: {
        total: null,
        individualization: {},
        Standardization: {},
        dataList: [],
        transverseData: [],
        colorList: [],
      },

      // 课程整体情况
      courseDataAll: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 近一年课程访问趋势
      courseVisit: {
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      // 近一年资源访问趋势
      resource: {
        dataList: [],
        transverseData: [],
        colorList: [],
      },

      // 各类型资源存储量
      typeResources: {
        dataList: [],
        sucai: {},
        rongliang: {},
      },
      extraResourceData:{
        talent_training_num:0,
        knowledge_graph_num:0,
        question_bank_use_rate_avg:0,
        teaching_standard_num:0,
        question_num:0
      },
      // 各类视频资源
      educationLevel: {
        videoPercent:0,
        smallCoursePercent:0,
        originalResourceNum:0,
        dataList: [],
        colorList: [],
        total: 0,
        transverseData: [],
        Max: {},
        xuni: {},
      },
      // 资源被访问量排名前十五
      resourceTable: {
        MaxArr: [],
        Max: {},
        MaxZykname: {},
        resourceAvg: null,
        resourceTotal: null,
      },
      // 国家专业大类
      getmajor: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      // 资源库访问量排名
      getzykTable: {
        dataList: [],
        transverseData: [],
        colorList: [],
        datas: [],
        FristArr: {},
        SecArr: {},
        ThrArr: {},
      },
      // 活跃用户数排名
      getzykACtive: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {},
        Thrid: {},
      },
      // 各省交流互动量排名（前十五名）
      userProvince: {
        dataList: [],
        from: {},
        studentUser: {},
        mapdatas: [],
        mapcolorList: ["#ffd9d9"],
        MaxArr: {},
        onilneMax: {},
        total: null,
        talkTotal: null,
        studyTotal: null,
      },
      // 课程数量分布
      curriculum: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: {},
        total: null,
      },

      // 各省课程建设及应用
      curriculProvince: {
        dataList: [],
        MaxArr: [],
        SerArr: [],
        total: null,
        stotal: null, // 标准化课程总数
        ptotal: null, // 个性化课程总数
        standard: {},
        personality: {},
      },

      // 资源库省份资源建设情况
      disksNum: {
        total: null,
        totalLog: null,
        dataList: [],
        MaxArr: {},
        buildMaxArr: [],
        buildMax: {},
        maxProvince: {},
      },

      // 资源库用户运行情况
      zykuserYun: {
        // 资源库用户月活情况分析
        userActiveTotal: null,
        userActiveData: [],
        userActiveTranserve: [],
        userActiveTotals: null,

        userActivelogNum: null,
        userActiveRoleData: [],
        userActiveRoleTranserve: [],
        userActiveRolelegendList: [],

        roleStudent: {},
        roleTeacher: {},
        roleEnterprise: {},
        roleSocial: {},

        userActiveMonthTransverseData: [],
        userActiveMonthDataList: [],
        roleTotal: null,
      },
      // 获取区间内每月新增用户数
      userAdd: {
        dataList: [],
        sAtdatas: [],
        Stotal: null,
        Ttotal: null,
        sAtlegendList: ["学生", "教师"],
        legendList: ["学生", "教师", "社会学习者", "企业用户"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 访问情况排名(前十五、后十五)
      userTop: {
        fristTop15: [],
        fristMax: {},
        last15: [],
        lastMax: [],
      },
      // 新增课程数
      courseNew: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 课程访问量排名
      courseTalkTable: {
        dataList: [],
        dataList1: [],
        dataList2: [],
        MaxArr: {},
        total: null,
      },

      // 资源库资源运行情况 （新增资源数） +（资源访问量）
      zyktalk: {
        total: null,
        totalLog: null,
        newRank: [],
        logRank: [],
        MaxArr: {},
        Top: {},
      },

      getZykH: {
        tableList: [],
      },
      provinceH: {
        tableList: [],
      },
      // 资源新增
      resourceNew: {
        dataList: [],
        transverseData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 课程访问量
      courseTrend: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      CountryUserAdd: {
        dataList: [],
        transverseData: [],
        legendList: ["教师", "学生"],
        Stotal: null,
        Ttotal: null,
      },
      CountryCurAdd: {
        // 月活
        userActiveMonthdataList: [],
        userActiveMonthTransverseData: [],
        userActiveTotal: null,
        // 用户月活 + 访问
        teacherActive: {},
        studentActive: {},
        societyActive: {},
        enterpriseActive: {},
        num: null,
        logNum: null,
        // 用户访问趋势图
        userVisitDataList: [],
        userVisitTransverseData: [],
        userVisitLegendList: [],
      },

      CountryVisit: {
        FristdataList: [],
        LastdataList: [],
        FristZykVisit: {},
      },

      CountryResourcesAdd: {
        countryAllResourceNum:0,
        total: null,
        logRank: null,
        newRank: [],
        logRank: [],
        visitRankTop1: {},
      },
      CountryCuourse: {
        allZykAddCourse:0,
        courseTotal: null,
        dataList: [],
        transverseData: [],
      },
      CountryCourseVisit: {
        dataList: [],
        Max: {},
      },
      userRunCase: {},
      studentSum: 0,
      loading: "", // 是否导出加载中

      // 现在的时间
      nowMonth: null,
      nowDay: "",
      type: "",
      nowYear: null,
      Quarter: "",
      startDay: "",
      detailTime: "",
      endDay: "",
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      sessionStorage.setItem("lrmv2token", token);
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.endDay.slice(0, 4);
      this.type = this.$route.query.type;
      const currentMonth = parseInt(this.startDay.split("-")[1]);
      let quarter_num =  Math.floor(currentMonth / 3) + 1;
      if (quarter_num == 1 && this.type == 2) {
        this.Quarter = "第1季度";
      } else if (quarter_num == 2 && this.type == 2) {
        this.Quarter = "第2季度";
      } else if (quarter_num == 3 && this.type == 2) {
        this.Quarter = "第3季度";
      } else if (quarter_num == 4 && this.type == 2) {
        this.Quarter = "第4季度";
      }
    }
    // 1. 监测总览
    this.nowDate();
    this.get1243ZykResourceStorage();
    this.get1243ZykProfessionClass();
    this.getZykMonitorDetail();
    this.dataAllHandler(); //       获取所有的国家数据总览
    this.getPlatFormNumByType_fn(); //获取平台数
    this.getExtraResourceData();
    this.resourceLevelHandler(); //       国家资源库个数
    this.zykUserNumHandler(); //       资源库用户数
    this.VisitAllHandler(); //       访问总体情况
    this.studentConstructionHandler(); //       学生类型整体情况
    this.visitUserHandler(); //       近一年用户访问情况（学生 + 老师 + 社会学习者 + 企业用户）
    this.getcourseHandler(); //       课程画像-课程数量图
    this.courseAllHandler(); //       课程整体情况
    this.courseVisitHanderl(); //       近一年课程访问趋势
    this.getResourceBuildAndAnalysisCase(); //近一年资源访问趋势
    this.resourcesrHandler(); //       资源素材数和储存容量
    this.resourcesProportion(); //       各类视频资源
    this.resourceTableHandler(); //       资源被访问量排名前十五
    this.getmajorHandler(); //       国家专业大类
    this.getzykHandler(); //       资源库访问量排名
    this.getzykACtiveHandler(); //       资源库活跃用户数排名
    this.getuserProHandeler(); //       各省资源库累计
    this.curriculumNumHandler(); //       课程数量分布
    this.curriculProvinceHandler(); //       资源库课程介绍
    this.disksNumHandler(); //       资源库省份资源建设情况
    this.userTimeTalkHanderl(); //       用户访问量趋势
    this.zykuserYunHandler(); //       资源库用户运行情况
    this.getZykUserActiveCase();
    this.getCountryZykUserRunCase();
    this.getUserBuildAndAnalysisCase();
    this.userAddHanderl(); //       每月新增用户数
    this.fristAlast(); //       资源库被用户访问情况排名分析
    this.courseNewHandler(); //       新增课程数量
    this.zykCourseRankHandler(); //       区间内课程访问量排名
    this.zyktalkHandler(); //       资源库资源运行情况
    this.getZykHandler();
    this.CountryUserAddHandler();
    this.CountryCurAddHandler();
    this.CountryVisitsRank();
    this.CountryCuourseAddHandler();
    this.CountryCurVisitHandler();
    this.CountryResourcesAddHandler();
    this.get1243ZykRankData(1);
    this.get1243ZykRankData(2);
    this.get1243ZykRankData(3);
    this.get1243ZykRankData(4);
    this.get1243ZykRankData(5);
    this.getAllResourceBuildApply();
    setTimeout(()=>{
      this.province();
    },20000)
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 截取当前日期的赋值操作
    nowDate() {
      let Frist = this.endDay.indexOf("-") + 1;
      let last = this.endDay.lastIndexOf("-") + 1;
      let regx = /^[0]+/;
      this.nowMonth = this.endDay.slice(Frist, last - 1).replace(regx, "");
      this.nowDay = this.endDay.slice(last, this.endDay.length);
    },
    formatValue(num) {
      return num.toFixed(2);
    },
    changeCity(val) {
      if(val!=undefined){
        val = val.replace("省", "").replace("市", "");
        if (val === "北京" || val === "重庆" || val === "天津" || val === "上海") {
          return val + "市";
        } else return val + "省";
      }
    },

    // 转化数字
    getUtils_Fun(num) {
      if(num == undefined){
        return 0;
      }
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num.toFixed(0).toString();
      return data;
    },

    // 导出pdf文件
    exportPdf() {
      let year = this.endDay.split("-")[0];
      let month = this.endDay.split("-")[1];
      const lableList = document.getElementsByClassName("page-box");
      if(this.type==1){
        pageToPDF(`${year}_新一轮专业教学资源库监测报告_${parseInt(month)}月`, this.$refs.pdfContent, lableList);
      }else if(this.type==2){
        pageToPDF(`${year}_新一轮专业教学资源库监测报告_${this.Quarter}`, this.$refs.pdfContent, lableList);
      }else if(this.type==3){
        pageToPDF(`${year}_新一轮专业教学资源库监测年度分析报告`, this.$refs.pdfContent, lableList);
      }
    },

    dataAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportOverview, {
          loading: false,
        })
        .then((res) => {
          this.dataAll.dataList = res.data;
          let datas = [];
          datas.push(
            {
              name: "资源库课程数",
              value: res.data.courseNum,
            },
            {
              name: "在线精品课数",
              value: res.data.onlineCourseNum,
            },
            {
              name: "视频公开课",
              value: res.data.videoCourseNum,
            }
          );
          // 资源库课程总数
          datas.forEach((item) => {
            this.dataAll.courseTotal += item.value;
          });
          this.completeNum = this.completeNum + 1;
        });
    },
    // 获取平台数
    getPlatFormNumByType_fn() {
      this.$axios.post(this.$apiurls.getPlatFormNumByType, { loading: false }).then((res) => {
        if (res.code === 200) {
          this.platformNum = res.data;
        }
        this.completeNum = this.completeNum + 1;
      });
    },
    // 获取额外的素材数
    getExtraResourceData() {
      this.$axios.post(this.$apiurls.getExtraResourceData, { loading: false }).then((res) => {
        if (res.code === 200) {
          this.extraResourceData = res.data;
        }
        this.completeNum = this.completeNum + 1;
      });
    },
    // 资源库个数
    resourceLevelHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getResourceBaseLevel, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.dataList.length; i++) {
              this.resourceLevel.dataList.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }
            this.resourceLevel.countryNum = this.resourceLevel.dataList.find(
              (item) => item.name == "原国家级"
            );
            this.resourceLevel.provinceNum = this.resourceLevel.dataList.find(
              (item) => item.name == "省市级"
            );
            this.resourceLevel.schoolNum = this.resourceLevel.dataList.find(
              (item) => item.name == "院校级"
            );
            this.resourceLevel.zyktotal = this.resourceLevel.dataList.find(
              (item) => item.name == "资源库总数"
            );
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 2.1.1 用户建设及应用分析
    getUserBuildAndAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getUserBuildAndAnalysisCase, { loading: false })
        .then((res) => {
          let sum = 0;
          res.data.studentType.forEach((item) => {
            sum += +item.value;
          });
          this.studentSum = sum;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 资源库用户数
    zykUserNumHandler() {
      this.$axios
        .post(this.$apiurls.getUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let data = res.data.userMap;
            this.zykUserNum = data;
            this.zykUserNum.realNameTeacher = res.data.realNameTeacher;
            this.zykUserNum.realNameStudent = res.data.realNameStudent;
            this.zykUserNum.dataList = [
              {
                name: "教师",
                value: data.teacher,
              },
              {
                name: "学生",
                value: data.student,
              },
              {
                name: "企业用户",
                value: data.enterprise,
              },
              {
                name: "社会学习者",
                value: data.social,
              },
              {
                name: "其他",
                value: data.other,
              },
            ];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 访问总体情况
    VisitAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportTotalLogModule, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.VisitAll.resource = res.data.resource;
            this.VisitAll.course = res.data.course;
            this.VisitAll.user = res.data.user;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 学生类型整体情况
    studentConstructionHandler() {
      this.$axios
        .post(this.$apiurls.userPortrait_getSumStudentTypeEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.studentConstruction.dataList = res.data.map((item) => {
              let name = item.name;
              let value = item.value;
              return {
                name,
                value,
              };
            });
            this.studentConstruction.dataList.forEach((item) => {
              this.studentConstruction.total += item.value - 0;
            });
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 获取近一年用户访问情况
    visitUserHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportUserMonthVisits, {
          loading: false,
        })
        .then((res) => {
          // 老师 + 学生访问趋势
          this.teaAstudVisit.dataList.push(res.data.teacher.value, res.data.student.value);
          this.teaAstudVisit.legendList = ["老师", "学生"];
          this.teaAstudVisit.transverseData = res.data.teacher.name;

          // 社会学习者 + 企业用户 访问量趋势
          this.enterAsoci.dataList.push(res.data.social.value, res.data.enterprise.value);
          this.enterAsoci.legendList = ["社会学习者", "企业用户"];
          this.enterAsoci.transverseData = res.data.social.name;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程画像 - 课程数量图
    getcourseHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getSumCourseTypeCountEchart, {
          loading: false,
        })
        .then((res) => {
          this.getcourse.Standardization = res.data.find((item) => item.name == "标准化课程");
          this.getcourse.individualization = res.data.find((item) => item.name == "个性化课程");
          this.getcourse.dataList = res.data.map((item, index) => {
            let name = item.name;
            let value = item.value;
            return {
              name,
              value,
            };
          });
          this.getcourse.total = res.data[0].value + res.data[1].value;
          this.getcourse.dataList.forEach((item) => {
            this.getcourse.transverseData.push(item.name);
          });

          this.getcourse.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 课程整体情况
    courseAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseState, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseDataAll.name = res.data.name;
            this.courseDataAll.zykDiv = res.data.zykDiv;
            this.courseDataAll.zykName = res.data.zykName;
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 近一年课程访问趋势
    courseVisitHanderl() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseMonthVisits, {
          loading: false,
        })
        .then((res) => {
          let data = res.data.course;
          this.courseVisit.dataList = data.value;
          this.courseVisit.transverseData = data.name;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 近一年资源访问趋势
    getResourceBuildAndAnalysisCase() {
      this.$axios
        .post(this.$apiurls.getResourceBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          let data = res.data.yearResourceVisit;
          this.resource.dataList = data.value;
          this.resource.transverseData = data.name;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源素材数和储存容量
    resourcesrHandler() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getResourceCount, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.dataList.length; i++) {
            this.typeResources.dataList.push({
              name: res.data.transverseData[i],
              value: res.data.dataList[i],
            });
          }
          this.typeResources.sucai = this.typeResources.dataList.find(
            (item) => item.name == "素材资源"
          );
          this.typeResources.rongliang = this.typeResources.dataList.find(
            (item) => item.name == "资源存储量"
          );
          this.completeNum = this.completeNum + 1;
        });
    },

    // 获取各资源素材类型占比情况
    resourcesProportion() {
      this.$axios
        .post(this.$apiurls.materialResources_getAllResourceCount, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.name.length; i++) {
              this.educationLevel.total += res.data.value[i];
              this.educationLevel.dataList.push({
                name: res.data.name[i],
                value: res.data.value[i],
              });
            }
            // this.educationLevel.dataList = this.educationLevel.dataList.filter(item => item.name != '其他')
            function Sort(a, b) {
              return b.value - a.value;
            }
            this.educationLevel.dataList.sort(Sort);

            // datas.forEach(item => {
            //   this.educationLevel.transverseData.push(item.name)
            //   this.educationLevel.dataList.push(item.value)
            // })
            this.educationLevel.Max = this.educationLevel.dataList[0];
            this.educationLevel.xuni = this.educationLevel.dataList.find(
              (item) => item.name == "虚拟仿真"
            );

            // 计算视频和微课的占比
            const videoIndex = res.data.name.indexOf("视频");
            const smallCourseIndex = res.data.name.indexOf("微课");

            if (videoIndex !== -1 && this.educationLevel.total > 0) {
              this.educationLevel.videoPercent = ((res.data.value[videoIndex] / this.educationLevel.total) * 100).toFixed(2);
            }

            if (smallCourseIndex !== -1 && this.educationLevel.total > 0) {
              this.educationLevel.smallCoursePercent = ((res.data.value[smallCourseIndex] / this.educationLevel.total) * 100).toFixed(2);
            }

            this.educationLevel.originalResourceNum = res.data.separateContent.find(
              (item) => item.name == "originalResourceNum"
            ).value;
            this.educationLevel.colorList = this.colorList;
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 获取所有资源素材应用情况
    getAllResourceBuildApply() {
      this.$axios
        .post(this.$apiurls.getAllResourceBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
              this.resourceBuildApply = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 资源被访问量排名（前十五名）
    resourceTableHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportResourceRank, {
          loading: false,
        })
        .then((res) => {
          this.resourceTable.dataList = res.data.resourceRank;
          this.resourceTable.resourceTotal = res.data.resourceTotal;
          this.resourceTable.resourceAvg = res.data.resourceAvg;
          this.resourceTable.MaxArr = this.resourceTable.dataList;

          function Sort(a, b) {
            return b.num - a.num;
          }
          this.resourceTable.MaxArr.sort(Sort);
          this.resourceTable.Max = this.resourceTable.MaxArr[0];
          this.resourceTable.dataList.forEach((item) => {
            let index = item.name.indexOf(",") + 1;
            let type = item.name.slice(index);
            let name = item.name.slice(0, index - 1);
            this.$set(item, "resourceType", type);
            this.$set(item, "name", name);
          });

          let datasMax = this.educationLevel.Max;
          datasMax.name = datasMax.name + "类";
          this.completeNum = this.completeNum + 1;
        });
    },

    // 国家专业大类
    getmajorHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykProfession, {
          loading: false,
        })
        .then((res) => {
          this.getmajor.dataList = res.data;
          this.getmajor.MaxArr = res.data[0];
          res.data.forEach((item) => {
            this.getmajor.total += item.value;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    getzykHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykLogRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykTable.dataList = res.data;
          this.getzykTable.FristArr = res.data[0];
          this.getzykTable.SecArr = res.data[1];
          this.getzykTable.ThrArr = res.data[2];

          let datas = res.data.map((item) => {
            let value = item.logNum;
            let name = item.zykName;
            return {
              value,
              name,
            };
          });

          function Sort(a, b) {
            return b.value - a.value;
          }
          datas.sort(Sort);
          datas.forEach((item) => {
            this.getzykTable.datas.push(item.value);
            this.getzykTable.transverseData.push(item.name);
          });
          this.getzykTable.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 获取资源库活跃用户数排名
    getzykACtiveHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykACtive.colorList = this.colorList;
          res.data.forEach((item) => {
            this.getzykACtive.dataList.push(item.value);
            this.getzykACtive.transverseData.push(item.name);
          });

          this.getzykACtive.Frist = res.data[0];
          this.getzykACtive.Second = res.data[1];
          this.getzykACtive.Thrid = res.data[2];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 各省用户建设及应用情况
    getuserProHandeler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykUserProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          let datas = res.data.activeUser;

          function Sort(a, b) {
            return b.num - a.num;
          }
          datas.sort(Sort);
          this.userProvince.from = res.data.form;
          this.userProvince.studentUser = res.data.studentUser;
          this.userProvince.dataList = res.data.activeUser;
          res.data.activeUser.forEach((item) => {
            this.userProvince.total += item.num;
            this.userProvince.talkTotal += item.formun;
            this.userProvince.studyTotal += item.activeNum;
          });

          this.userProvince.MaxArr = res.data.studentUser;

          res.data.provinceLog.push(
            {
              name: "西藏",
              value: 0,
            },
            {
              name: "台湾",
              value: 0,
            },
            {
              name: "香港",
              value: 0,
            },
            {
              name: "青海",
              value: 0,
            },
            {
              name: "澳门",
              value: 0,
            }
          );
          this.userProvince.mapdatas = res.data.provinceLog;
          function Sort(a, b) {
            return b.activeNum - a.activeNum;
          }
          this.userProvince.dataList.sort(Sort);
          this.userProvince.onilneMax = this.userProvince.dataList[0];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程数量分布
    curriculumNumHandler() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getSchoolCourseProvinceRanking, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.curriculum.dataList = res.data.dataList;
            this.curriculum.legendList = res.data.transverseData;
            let datas = [];
            for (let i = 0; i < this.curriculum.dataList.length; i++) {
              this.curriculum.total += this.curriculum.dataList[i];
              datas.push({
                name: this.curriculum.legendList[i],
                value: this.curriculum.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.curriculum.sortMax = datas;
            this.curriculum.MaxArr = this.curriculum.sortMax[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    curriculProvinceHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          this.curriculProvince.dataList = res.data.courseRank;
          this.curriculProvince.MaxArr = this.curriculProvince.dataList[0];
          this.curriculProvince.SerArr = this.curriculProvince.dataList[1];

          res.data.courseRank.forEach((item) => {
            this.curriculProvince.total += item.num;
            this.curriculProvince.stotal += item.snum;
            this.curriculProvince.ptotal += item.pnum;
          });
          res.data.standard = this.curriculProvince.dataList.find((item) => item.name == "湖南");
          this.curriculProvince.standard = res.data.standard;

          res.data.personality = this.curriculProvince.dataList.find(
            (item) => item.name == "广东"
          );
          this.curriculProvince.personality = res.data.personality;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库省份建设情况
    disksNumHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKResourceProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          // this.disksNum.maxProvince = res.data.maxProvince
          this.disksNum.dataList = res.data.provinceRank;

          this.disksNum.MaxArr = this.disksNum.dataList[0];
          this.disksNum.dataList.forEach((item) => {
            this.disksNum.total += item.log;
            this.disksNum.totalLog += item.count;
          });

          // 按照资源数排名
          this.disksNum.buildMaxArr = this.disksNum.dataList;
          function Sort(a, b) {
            return b.count - a.count;
          }
          this.disksNum.buildMaxArr.sort(Sort);
          this.disksNum.buildMax = this.disksNum.buildMaxArr[0];

          // 按照访问量排名
          function Sorts(a, b) {
              return b.log - a.log;
          }
          this.disksNum.dataList.sort(Sorts);
          this.completeNum = this.completeNum + 1;
        });
    },

    userTimeTalkHanderl() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportUserMonthVisitsRange,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.zykuserYun.userActiveData = res.data.value;
            res.data.value.forEach((item) => {
              this.zykuserYun.userActiveTotals += item;
            });
            this.zykuserYun.userActiveTranserve = res.data.name;
            this.zykuserYun.colorList = this.colorList;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库用户运行情况
    zykuserYunHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKUserActiveStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          // 累计活跃用户
          // （1）资源库用户月活情况分析
          // this.zykuserYun.userActiveTotal = res.data.userActiveTotal
          let datas1 = [];
          let datas2 = [];
          res.data.userActiveMonth.forEach((item) => {
            console.log(item)
            datas1.push(item.value);
            datas2.push(item.name);
            this.zykuserYun.userActiveTotal += item.value;
          });

          this.zykuserYun.userActiveData = datas1;
          this.zykuserYun.userActiveTranserve = datas2;

          // （2）资源库用户访问情况分析
          // 标题数据统计
          res.data.userActive.forEach((item) => {
            this.zykuserYun.userActivelogNum += item.logNum;
          });
          // 创建一个新数组
          let newRoleArr = res.data.userActive.map((item) => {
            let num = item.num;
            let logNum = item.logNum;
            let role = item.role;
            return {
              num,
              logNum,
              role,
            };
          });

          // 单独的每位用户数组
          this.zykuserYun.roleStudent = newRoleArr.find((item) => item.role == "学生");
          this.zykuserYun.roleTeacher = newRoleArr.find((item) => item.role == "教师");
          this.zykuserYun.roleEnterprise = newRoleArr.find((item) => item.role == "企业用户");
          this.zykuserYun.roleSocial = newRoleArr.find((item) => item.role == "社会学习者");
          // this.zykuserYun.roleTotal =
          //   this.zykuserYun.roleStudent.num +
          //   this.zykuserYun.roleTeacher.num +
          //   this.zykuserYun.roleEnterprise.num +
          //   this.zykuserYun.roleSocial.num;

          this.zykuserYun.userActiveRoleData = res.data.userActiveMonthRole.dataList;
          this.zykuserYun.userActiveRoleTranserve = res.data.userActiveMonthRole.transverseData;
          this.zykuserYun.userActiveRolelegendList = res.data.userActiveMonthRole.legendList;
          this.zykuserYun.colorList = this.colorList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 2.3.1 资源库用户建设及应用情况 2. 用户活跃情况
    getZykUserActiveCase() {
      this.$axios
        .post(
          this.$apiurls.getZykUserActiveCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.activeUserTotal = res.data.userActiveTotal;
          let sum = 0;
          res.data.userActive.forEach((item) => {
            sum += item.logNum;
          });
          this.logTotal = sum;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 每月新增用户数
    userAddHanderl() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportUserMonthNew,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          //  图13
          this.userAdd.transverse = res.data.enterprise.name;

          this.userAdd.dataList.push(
            res.data.student.value,
            res.data.teacher.value,
            res.data.enterprise.value,
            res.data.social.value
          );

          this.userAdd.colorList = this.colorList;
          let studentV = this.userAdd.dataList[0];
          let teacherV = this.userAdd.dataList[1];
          // 图 31
          this.userAdd.sAtdatas.push(studentV, teacherV);
          studentV.forEach((item) => {
            this.userAdd.Stotal += item;
          });
          teacherV.forEach((item) => {
            this.userAdd.Ttotal += item;
          });
          this.userAdd.total = this.userAdd.Stotal + this.userAdd.Ttotal;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 资源库被用户访问情况排名分析
    fristAlast() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKVisitsRank,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userTop.fristTop15 = res.data.slice(0, 15);
          this.userTop.fristMax = this.userTop.fristTop15[0];

          this.userTop.last15 = res.data.slice(-15);
          this.userTop.lastMax = this.userTop.last15[this.userTop.last15.length - 1];
          // 降级排序
          function Sort(a, b) {
            return a.num - b.num;
          }
          this.userTop.last15.sort(Sort);
          this.completeNum = this.completeNum + 1;
        });
    },

    // 新增课程数
    courseNewHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportMonthRange,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.courseNew.dataList = res.data.courseNew.value;
            this.courseNew.transverse = res.data.courseNew.name;
            this.courseNew.dataList.forEach((item) => {
              this.courseNew.total += item;
            });
            this.courseNew.sNum = res.data.sNum;
            this.courseNew.pNum = res.data.pNum;

            // 课程访问量
            this.courseTrend.dataList = res.data.courseVisits.value;
            this.courseTrend.transverse = res.data.courseVisits.name;
            this.courseTrend.dataList.forEach((item) => {
              this.courseTrend.total += item;
            });

            // 资源新增
            this.resourceNew.dataList = res.data.resourceNew.value;
            this.resourceNew.transverseData = res.data.resourceNew.name;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    zykCourseRankHandler() {
      let dataType = 0;
      if(this.type == 1){
        dataType = 55
      }else if(this.type == 2){
        dataType = 56
      }
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseRank,dataType, {
          loading: false,
        })
        .then((res) => {
          let data = res.data;
          this.courseTalkTable.dataList = data;
          this.courseTalkTable.MaxArr = data[0];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库资源运行情况
    zyktalkHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKResourceStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zyktalk.total = res.data.total;
          this.zyktalk.totalLog = res.data.totalLog;
          this.zyktalk.newRank = res.data.newRank;
          this.zyktalk.Top = res.data.newRank[0];
          let data = res.data.resourceDistribution;
          this.zyktalk.resourceDistribution = [
            {
              name: "视频",
              value: data.video,
            },
            {
              name: "图形图像",
              value: data.image,
            },
            {
              name: "文本",
              value: data.text,
            },
            {
              name: "PPT和富媒体",
              value: data.ppt + data.media + data.courseware,
            },
            {
              name: "动画",
              value: data.animation,
            },
            {
              name: "微课",
              value: data.microCourses,
            },
            {
              name: "音频",
              value: data.audio,
            },
            {
              name: "虚拟仿真",
              value: data.simulation,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.zyktalk.total = data.video + data.image + data.text + data.ppt + data.media + data.courseware + data.animation + data.microCourses + data.audio + data.simulation + data.other;
          this.zyktalk.logRank = res.data.logRank;

          function Sort(a, b) {
            return b.num - a.num;
          }

          this.zyktalk.logRank.sort(Sort);
          this.zyktalk.MaxArr = this.zyktalk.logRank[0];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库年报_按专业大类分布
    getZykHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getZykProfessionClassify, {
          loading: false,
        })
        .then((res) => {
          this.getZykH.tableList = res.data.splice(0, 15);
          this.completeNum = this.completeNum + 1;
        });
    },

    // 资源库用户新增情况分析
    CountryUserAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZykUserMonthNew,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.CountryUserAdd.allZykUserAddNum = res.data.allZykUserAddNum;
          this.CountryUserAdd.dataList.push(res.data.student.value, res.data.teacher.value);
          this.CountryUserAdd.transverseData = res.data.teacher.name;
          this.CountryUserAdd.colorList = this.colorList;

          res.data.teacher.value.forEach((item) => {
            this.CountryUserAdd.Stotal += item;
          });

          res.data.student.value.forEach((item) => {
            this.CountryUserAdd.Ttotal += item;
          });
          this.CountryUserAdd.total = this.CountryUserAdd.Stotal + this.CountryUserAdd.Ttotal;
          this.completeNum = this.completeNum + 1;
        });
    },

    CountryCurAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZyKUserActiveStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          // 月活
          res.data.userActiveMonth.forEach((item) => {
            this.CountryCurAdd.userActiveMonthdataList.push(item.value);
            this.CountryCurAdd.userActiveMonthTransverseData.push(item.name);
          });
          this.CountryCurAdd.userActiveTotal = res.data.userActiveTotal;
          this.CountryCurAdd.colorList = this.colorList;

          // 用户月活 + 访问
          this.CountryCurAdd.teacherActive = res.data.userActive.find(
            (item) => item.role == "教师"
          );
          this.CountryCurAdd.studentActive = res.data.userActive.find(
            (item) => item.role == "学生"
          );
          this.CountryCurAdd.societyActive = res.data.userActive.find(
            (item) => item.role == "社会学习者"
          );
          this.CountryCurAdd.enterpriseActive = res.data.userActive.find(
            (item) => item.role == "企业用户"
          );
          let totalNum1 = this.CountryCurAdd.teacherActive.num;
          let totalNum2 = this.CountryCurAdd.studentActive.num;
          let totalNum3 = this.CountryCurAdd.societyActive.num;
          let totalNum4 = this.CountryCurAdd.enterpriseActive.num;

          let logNum1 = this.CountryCurAdd.teacherActive.logNum;
          let logNum2 = this.CountryCurAdd.studentActive.logNum;
          let logNum3 = this.CountryCurAdd.societyActive.logNum;
          let logNum4 = this.CountryCurAdd.enterpriseActive.logNum;
          this.CountryCurAdd.num = totalNum1 + totalNum2 + totalNum3 + totalNum4;
          this.CountryCurAdd.logNum = logNum1 + logNum2 + logNum3 + logNum4;

          // 用户访问趋势图
          this.CountryCurAdd.userVisitDataList = res.data.userActiveMonthRole.dataList;
          this.CountryCurAdd.userVisitTransverseData = res.data.userActiveMonthRole.transverseData;
          this.CountryCurAdd.userVisitLegendList = res.data.userActiveMonthRole.legendList;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 2.3.4.1 用户运行情况
    getCountryZykUserRunCase() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykUserRunCase,
          { endDay: this.endDay, startDay: this.startDay, type: 0 },
          {
            loading: false,
          }
        )
        .then((res) => {
          let sum = 0;
          res.data.userActiveCase.userActive.forEach((item) => {
            sum += item.logNum;
          });
          this.userRunCase.logTotal = sum;
          this.userRunCase.activeUserTotal = res.data.userActiveCase.userActiveTotal;
          this.completeNum = this.completeNum + 1;
        });
    },
    CountryVisitsRank() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZyKVisitsRank,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.CountryVisit.FristdataList = res.data.slice(0, 15);
          this.CountryVisit.FristZykVisit = this.CountryVisit.FristdataList[0];
          this.CountryVisit.LastdataList = res.data.slice(-15);
          // 降级排序
          function Sort(a, b) {
            return a.num - b.num;
          }
          this.CountryVisit.LastdataList.sort(Sort);
          this.completeNum = this.completeNum + 1;
        });
    },
    // 获取区间内国家级资源库课程新增趋势
    CountryCuourseAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZykMonthRange,
          {
            startDay: this.startDay,
            endDay: this.endDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          res.data.value.forEach((item) => {
            this.CountryCuourse.courseTotal += item;
          });
          this.CountryCuourse.dataList = res.data.value;
          this.CountryCuourse.transverseData = res.data.name;
          let separateContent = res.data.separateContent;
          this.CountryCuourse.standardNum = separateContent.find(
            (item) => item.name === "standardNum"
          ).value;
          this.CountryCuourse.personalityNum = separateContent.find(
            (item) => item.name === "personalityNum"
          ).value;
          this.CountryCuourse.allZykAddCourse = separateContent.find(
            (item) => item.name === "allZykAddCourse"
          ).value;
          this.completeNum = this.completeNum + 1;
        });
    },
    // 区间内国家级资源库课程访问量排名
    CountryCurVisitHandler() {
      let dataType = 0;
      if(this.type == 1){
          dataType = 52
      }else if(this.type == 2){
          dataType = 53
      }
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCountryZyKCourseRank, dataType, {
          loading: false,
        })
        .then((res) => {
          this.CountryCourseVisit.dataList = res.data;
          this.CountryCourseVisit.Max = res.data[0];
          this.completeNum = this.completeNum + 1;
        });
    },
    CountryResourcesAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZyKResourceStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.CountryResourcesAdd.allZykAddTotal = res.data.allZykAddTotal;
          this.CountryResourcesAdd.total = res.data.total;
          this.CountryResourcesAdd.totalLog = res.data.totalLog;
          this.CountryResourcesAdd.newRank = res.data.newRank;
          this.CountryResourcesAdd.logRank = res.data.logRank;
          this.CountryResourcesAdd.visitRankTop1 = this.CountryResourcesAdd.logRank[0];
          console.log(this.CountryResourcesAdd);
          let data = res.data.resourceDistribution;
          this.CountryResourcesAdd.resourceDistribution = [
            {
              name: "视频",
              value: data.video,
            },
            {
              name: "图形图像",
              value: data.image,
            },
            {
              name: "文本",
              value: data.text,
            },
            {
              name: "PPT和富媒体",
              value: data.ppt + data.media + data.courseware,
            },
            {
              name: "动画",
              value: data.animation,
            },
            {
              name: "微课",
              value: data.microCourses,
            },
            {
              name: "音频",
              value: data.audio,
            },
            {
              name: "虚拟仿真",
              value: data.simulation,
            },
            {
              name: "其他",
              value: data.other,
            },
          ];
          this.completeNum = this.completeNum + 1;
        });
    },

    province() {
      this.$axios
        .post(this.$apiurls.provinceReport_getZykProvinceClassify, {
          loading: false,
        })
        .then((res) => {
          this.provinceH.tableList = res.data.splice(0, 15);
          this.completeNum = this.completeNum + 1;
        });
    },
    getZykMonitorDetail(){
      this.$axios
        .get(this.$apiurls.getZykMonitorDetail, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            this.zykMonitorDetail = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    get1243ZykProfessionClass(){
      this.$axios
        .get(this.$apiurls.get1243ZykProfessionClass, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            this.zykProfessionClass = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },get1243ZykResourceStorage(){
      this.$axios
        .get(this.$apiurls.get1243ZykResourceStorage, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            this.zykResourceStorage = res.data;
          }
          this.completeNum = this.completeNum + 1;
        });
    },get1243ZykRankData(sortType){
      this.$axios
        .get(this.$apiurls.get1243ZykRankData+"?sortType="+sortType, {
          loading: false,
        })
        .then((res) => {
          if (res.data) {
            if(sortType == 1){
              this.zykWholeRankSorByUserNum = res.data;
            }else if(sortType == 2){
              this.zykWholeRankSorByActiveUserNum = res.data;
            }else if(sortType == 3){
              this.zykWholeRankSorByCourseCount = res.data;
            }else if(sortType == 4){
              this.zykWholeRankSorByResourceNum = res.data;
            }else if(sortType == 5){
              this.zykWholeRankSorByLogNum = res.data;
            }
          }
          this.completeNum = this.completeNum + 1;
        });
    }

  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  /* height: 43840px; */
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /*width: 70%;*/
  /* width: 86.7%;
  margin: 0px auto; */
  /* height: 32880px; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 40px 0 60px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}

.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  position: relative;
  clear: both;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
  margin: 35px 0;
}

.chart_box {
  width: 100%;
  height: auto;
  clear: both;
  display: flex;
  flex-direction: column;
}

.chart_box,
.catalogue h3 {
  font-weight: 700;
  color: #1d244e;
}

.catalogue h3 {
  margin-top: 50px;
  font-size: 60px;
  margin-bottom: 15px;
}

.chart_box h3 {
  font-size: 50px;
  margin-top: 30px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
}

.catalogue h4 {
  margin-top: 50px;
  margin-bottom: 15px;
}

.chart_box h4 {
  font-size: 42px;
  margin-bottom: 35px;
  margin-top: 30px;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  color: #1d244e;
  /*text-indent: 40px;*/
  /* line-height: 40px; */
}

.catalogue h5 {
  font-size: 45px;
  margin-top: 50px;
  margin-bottom: 15px;
  line-height: 40px;
}

.chart_box h5 {
  font-size: 40px;
  margin-bottom: 35px;
  margin-top: 30px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 40px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-top: 30px;
  margin-bottom: 35px;
  /* margin-bottom: 15px;
  margin-top: 50px; */
}

.chart_box p {
  font-weight: 540;
  font-size: 35px;
  text-indent: 2em;
  line-height: 70px;
  color: #272a3f;
}

.chart_box .echartsHeight,
.layout,
.speed {
  /* width: 80%; */
  height: calc(100vw / 1080 * 300);
  /* height: auto; */
  /* height: 400px; */
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 32px;
  color: #272a3f;
  clear: both;
  margin-top: 20px;
}

.chart_box .notes {
  margin-top: 50px;
  line-height: 50px;
  font-size: 30px;
  color: black;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.center {
  text-align: center;
}

.divorced {
  margin-top: 40px;
}

.biaoge {
  height: 720px;
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  margin-bottom: 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 26px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  padding-left: 10%;
  padding-top: 18%;
}

.HomePage #image {
  width: 559px;
  height: 70px;
  background: url("../../../../public/pdf_year.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin: 36% 0;
  padding: 20px 0px 20px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 65px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#foot {
  display: flex;
}

.HomePage .footBox {
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 42px;
  margin-left: 19.5%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

.catalogue {
  position: relative;
  /* padding: 10% 0px 0px 10%; */
  /* padding-left: 10%; */
  /* margin-top: 300px; */
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}

.top {
  margin-top: 140px;
}
</style>

<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // border: 1px solid red;
  .biaoge {
    width: 95%;
    margin: 25px auto;

    .course {
      text-align: center;
      margin: 0px 10px;

      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;

        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }

        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
  .m-top150 {
    margin-top: 150px;
  }
}

.catalogue {
  .title {
    text-align: center;
    margin-bottom: 4%;
    font-size: 40px;
  }

  .Second_text {
    padding-left: 1.8em;
  }

  .Thred_text {
    padding-left: 7.69em;
  }

  h5 {
    display: flex;
    align-items: center;

    .dot {
      flex: 1;
      border-top: dotted #1d244e 7px;
      /* 可设置大小，查属性参数dotted可换其他样式 */
      margin: 0 10px;
      /* 用来控制文字与填充线的间隔大小 */
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
